import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import PropTypes from 'prop-types'

import { localize } from 'helpers/translator'
import BodymovinSegments from 'components/bodymovin/bodymovin_segments'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import Ellipsis from 'components/ellipsis/ellipsis'
import animationPaths from 'animations/paths'
import styles from './first_lesson_loading.scss'

const segments = {
	start: {segment: [0, 774], loop: false},
	exit: {segment: [0, 37], loop: false},
}

class FirstLessonLoading extends PureComponent {

	constructor() {
		super()
		this.state = {
			componentStatus: 'init',
			shouldShowLoadingText: false,
			text: 0,
		}
		this.loadingListeners = {
			onLoaded: this.startAnimation.bind(this),
			onComplete: this.animationCompleted.bind(this),
		}
		this.titles = [
			localize('first_lesson_overlay_loading_title1'),
			localize('first_lesson_overlay_loading_title2'),
			localize('first_lesson_overlay_loading_title3'),
		]
		this.subtitle = [
			localize('first_lesson_overlay_loading_subtitle1_live_participation'),
			localize('first_lesson_overlay_loading_subtitle2'),
			localize('first_lesson_overlay_loading_subtitle3'),
		]
	}

	animationCompleted() {
		this.setState({
			componentStatus: 'exit',
			shouldShowLoadingText: true,
		})
		this.props.animationCompleted()
	}

	startAnimation() {
		this.setState({
			componentStatus: 'start',
			text: 1,
		})

		this.timerId = setTimeout(() => {
			this.setState({
				text: 2,
			})
			this.timerId = setTimeout(() => {
				this.setState({
					text: 3,
				})
			}, 8500)
		}, 7000)
	}

	componentWillUnmount() {
		clearTimeout(this.timerId)
	}

	renderElement(title, subtitle) {
		return (
			<div styleName='header-content'>
				<h1 styleName='header-content-title'>{title}</h1>
				<h2 styleName='header-content-subtitle'>{subtitle}</h2>
			</div>
		)
	}

	render() {
		return (
			<div styleName='wrapper'>
				<TransitionGroup styleName='header'>
					<CSSTransition
						key={`text${this.state.text}`}
						classNames={{
							enter: styles.enter,
							enterActive: styles['enter-active'],
							exit: styles.exit,
							exitActive: styles['exit-active'],
						}}
						timeout={{ enter: 1150, exit: 550 }}
					>
						{ this.renderElement(this.titles[this.state.text-1], this.subtitle[this.state.text-1]) }
					</CSSTransition>
				</TransitionGroup>
				<BodymovinSegments
					name='loading'
					listeners={this.loadingListeners}
					settings={{
						path: animationPaths.FIRST_LESSON_LOADING,
					}}
					segments={segments}
					segment={this.state.componentStatus}
				>
					<div styleName='animation'></div>
				</BodymovinSegments>
				{ this.state.shouldShowLoadingText &&
					<div styleName='footer'>Importing<Ellipsis /></div>
				}
			</div>
		)
	}
}

FirstLessonLoading.propTypes = {
	animationCompleted: PropTypes.func,
}

FirstLessonLoading.defaultProps = {
	animationCompleted: () => {},
}

export default CSSModules(FirstLessonLoading, styles, {allowMultiple: true})
